import "./CardGrid.scss";

import clsx from "clsx";

import { FCCC } from "@/types";

/**
 * Grid for fixed-width `ProductCard`s: as many 328px columns as the content
 * zone fits (two from the desktop breakpoint up, one below), 24px gap. Unlike
 * `TilesGrid` it carries no minimum height, so a short row of cards does not
 * reserve empty space below itself.
 */
export const CardGrid: FCCC = ({ className, children }) => (
  <div className={clsx("card-grid", className)}>{children}</div>
);
